<template>
  <div
    class="page_container addCommondity"
    v-loading="loading"
    element-loading-text="提交中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >SKU管理</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/commondityIndex/cManageIndex' }"
          >商品管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>新增商品</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 主要内容 start -->
    <div class="form_container">
      <h1>新增商品</h1>
      <div class="content_wrap flex-rowl">
        <div class="form_wrap">
          <div class="block">
            <p><span class="mark">*</span>商品名称设置：</p>
            <div class="input_box">
              <el-input
                v-model="formData.commodityname"
                placeholder="输入商品中文名称"
              ></el-input>
            </div>
            <div class="input_box">
              <el-input
                v-model="formData.commodityname_e"
                placeholder="Enter product name"
              ></el-input>
            </div>
            <div class="input_box">
              <el-input
                v-model="formData.commodityname_m"
                placeholder="Nhập tên sản phẩm"
              ></el-input>
            </div>
            <div class="input_box">
              <el-input
                v-model="formData.commodityname_y"
                placeholder="Masukkan nama produk"
              ></el-input>
            </div>
            <div class="input_box">
              <el-input
                v-model="formData.commodityname_t"
                placeholder="ป้อนชื่อสินค้า"
              ></el-input>
            </div>
          </div>
          <div class="block">
            <p><span class="mark">*</span>商品SKU采购编码，ISBN编码设置：</p>
            <p class="red">
              请注意，SKU采购编码，和
              ISBN编码一旦设置不可更改，为了您的数据管理严谨性，请谨慎输入！
            </p>
            <div class="input_box">
              <el-input
                v-model="formData.sku"
                placeholder="输入SKU采购编码"
              ></el-input>
            </div>
            <div class="input_box">
              <el-input
                v-model="formData.ISBN"
                placeholder="输入ISBN编码"
              ></el-input>
            </div>
          </div>
          <div class="block">
            <p><span class="mark">*</span>商品品牌设置：</p>
            <p class="red">
              请注意，商品的品牌信息一经设置不可更改，为了您的数据管理严谨性，请谨慎输入！
            </p>
            <div class="input_box" @click="handleShowBrand">
              <el-input
                v-model="brandName"
                placeholder="选择设置品牌"
                readonly
              ></el-input>
            </div>
          </div>
        </div>
        <div class="tip_wrap">
          <p>商品添加注意事项：</p>
          <p class="red">
            请注意，商品一经添加后，如需删除，请联系系统超级管理员。<br />
            添加的商品为你的企业所专属的商品。<br />
            添加完成后，系统将自动赋予商品ID，并与你的企业ID关联，随后请进一步完善商品详细信息。
          </p>
        </div>
      </div>
       <div class="form_footer flex-rowl">
        <div class="btn" @click="query">确认</div>
        <div class="return_txt" @click="handleReturn">←返回</div>
      </div>
    </div>
    <!-- 主要内容 end -->

    <!-- 品牌添加 -->
    <div class="custom_dialog" v-show="isShow">
      <div class="custom_wrap">
        <div class="close_icon" @click="isShow = false">
          <i class="iconfont icon-guanbi"></i>
        </div>
        <div class="diaog_body">
          <h1>商品品牌设置：</h1>
          <p>
            请注意，品牌一经设置不可更改，为了您的数据管理严谨性，请谨慎输入！
          </p>
          <div class="search_box flex-between">
            <el-input
              v-model="searchText"
              placeholder="输入商品关键字查找→"
            ></el-input>
            <div class="search_btn flex-rowc">
              <i class="iconfont icon-chazhaotubiao"></i>
            </div>
          </div>
          <div class="radio_wrap">
            <!-- <el-radio-group v-model="formData.brandid" direction="horizontal">
              <el-radio
                v-for="item in brandList"
                :key="item.id"
                checked-color="#ee0a24"
                :label="item.id"
                >{{ item.labelname }}</el-radio
              >
            </el-radio-group> -->
            <div class="radio_group flex-rowl">
              <div
                class="radio_item flex-rowl"
                v-for="item in brandList"
                :key="item.id"
                @click="handleBrand(item)"
              >
                <i
                  class="iconfont"
                  :class="
                    barndId == item.id ? 'icon-danxuanyixuan1' : 'icon-quanxuan'
                  "
                ></i>
                {{ item.labelname }}
              </div>
            </div>
          </div>
        </div>
        <div class="dialog_footer flex-between">
          <div class="form_footer flex-rowl">
            <div class="btn" @click="handleQueryBanrd">确认</div>
            <div class="return_txt" @click="handleCloseBrand">←返回</div>
          </div>
          <div class="link">
            <router-link to="/brandIndex/brandDetail"
              >前往添加品牌→</router-link
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getBrandList, addCommidity } from "../../api/api";
export default {
  name: "addCommondity",
  data() {
    return {
      isShow: false,

      searchText: "",

      loading: false,
      barndId: "", // 选中品牌id
      brandName: "", // 选中品牌name
      brandItem: "", // 选中品牌item
      brandList: "", // 品牌列表
      formData: {
        Method: "ams_shop_commodityadd",
        commodityname: "",
        commodityname_e: "",
        commodityname_m: "",
        commodityname_y: "",
        commodityname_t: "",
        sku: "",
        ISBN: "",
        brandid: "",
        shortname: "",
        shortname_e: "",
        shortname_m: "",
        shortname_y: "",
        shortname_t: "",
        comtype: "",
        labelid: "",
        labelid2: "",
        labelid3: "",
        paytype: "",
        groupnum: "",
        qyid: "",
        openid: "",
        createman: "",

        istop: 0, // 是否置顶
        isintro: "否", // 是否精品推荐
        ispre: false, // 是否预售
        islimit: "不限购", // 是否限购
        commoditystate: "下架", // 是否上架
        salestate: "正常销售", // 销售状态
      },
    };
  },
  created() {
    let userInfo = this.$store.state.USERINFO;
    if (userInfo.qy) {
      this.formData.qyid = userInfo.qy.id;
    } else {
      this.formData.qyid = 0;
    }
    this.formData.openid = userInfo.openid;
    this.formData.createman = userInfo.truename
      ? userInfo.truename
      : userInfo.nickname;
    this.getBrand();
  },
  methods: {
    // 品牌标签
    getBrand() {
      let { qyid } = this.formData;
      getBrandList({ qyid }).then((res) => {
        this.brandList = res;
      });
    },
    // 品牌单选
    handleBrand(item) {
      this.brandItem = item;
      this.barndId = item.id;
    },
    // 品牌确认
    handleQueryBanrd() {
      let { barndId, brandItem } = this;
      if (barndId == "") {
        this.$message.warning("请选择品牌");
        return;
      } else {
        this.brandName = brandItem.labelname;
        this.formData.brandid = brandItem.id;
        this.isShow = false;
      }
    },
    // 显示弹窗
    handleShowBrand() {
      this.isShow = true;
      this.barndId = this.formData.brandid;
    },
    // 关闭弹窗
    handleCloseBrand() {
      this.isShow = false;
      this.barndId = "";
    },
    // 返回上一页
    handleReturn() {
      history.back();
    },

    // 提交数据
    query() {
      let { formData } = this;
      if (formData.commodityname == "") {
        this.$message.warning("请输入商品名称");
        return;
      }
      if (formData.commodityname.length <= 2) {
        this.$message.warning("请输入商品名称最少2个字符");
        return;
      }
      if (formData.sku == "") {
        this.$message.warning("请输入SKU采购编码");
        return;
      }
      if (formData.ISBN == "") {
        this.$message.warning("请输入ISBN编码");
        return;
      }
      if (formData.brandid == "") {
        this.$message.warning("请选择商品品牌");
        return;
      }
      this.loading = true;
      addCommidity(formData).then((res) => {
        if (res.result) {
          // let message = this.$message.success(res.message);
          // message.close();
          setTimeout(() => {
            this.loading = false;
            this.$router.back();
          }, 500);
        } else {
          this.loading = false;
          this.$message.error(res.message || "服务器报错，请稍后～");
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.addCommondity {
  .form_container {
    background: #f6f6f6;
    padding: 39px 70px 90px;
    margin-top: 17px;
    height: 47vh;
    overflow-y: scroll;
    h1 {
      font-size: 20px;
      color: #404d6c;
      margin-bottom: 28px;
    }
    .content_wrap {
      align-items: flex-start;
      .form_wrap {
        flex: 1;
        margin-right: 100px;
        .block {
          margin-bottom: 45px;
          .input_box {
            margin-bottom: 20px;
          }
        }
      }
      .tip_wrap {
        flex: 1;
      }
      p {
        font-size: 18px;
        color: #6e6e6e;
        margin-bottom: 8px;
        &.red {
          font-size: 16px;
          color: #ff0012;
          line-height: 26px;
          // margin-bottom: 0;
        }
        .mark {
          color: #ff0012;
          font-size: 14px;
          margin-right: 4px;
        }
      }
    }
  }
  .custom_wrap {
    width: 40%;
    height: 49%;
    // padding-right: 30px;
    .diaog_body {
      height: 44vh;
      h1 {
        font-size: 18px;
        color: #6e6e6e;
      }
      p {
        font-size: 14px;
        color: #ff0012;
        margin: 15px 0 14px;
      }
      .search_box {
        width: 80%;
        height: 40px;
        background: #ffffff;
        border: 1px solid rgba(173, 173, 173, 0.76);
        border-radius: 25px;
        /deep/ .el-input__inner {
          border: none;
          background: none;
        }
        .search_btn {
          width: 60px;
          cursor: pointer;
        }
      }
      .radio_wrap {
        height: 25vh;
        margin-top: 25px;
        overflow-y: scroll;
        .radio_group {
          flex-wrap: wrap;
          .radio_item {
            margin-right: 80px;
            font-size: 14px;
            color: #6e6e6e;
            margin-bottom: 20px;
            cursor: pointer;
            .iconfont {
              font-size: 22px;
              margin-right: 5px;
              color: #a5a5a5;
              &.icon-danxuanyixuan1 {
                color: #ea4e4e;
              }
            }
          }
        }
      }
    }
    .dialog_footer {
      .link {
        a {
          font-size: 16px;
          color: #fe3c46;
        }
      }
    }
  }
}
</style>